import { createFileRoute } from '@tanstack/react-router'

import { RootRoute } from '@/pages/home/route-entries/root-route'

export const Route = createFileRoute('/_layout/')({
  component: RootRoute,
})
